// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — items.styled.classic.js, новая — items.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './items.styled.classic';
import * as cp from './items.styled.cp';

export const Connector = isCp ? cp.Connector : undefined;
export const Content = isCp ? cp.Content : classic.Content;
